module.exports = __webpack_public_path__ + "static/media/red-arrow.svg";